import React from 'react';
import './DevLog.css';

const DevLog = () => {
  const devUpdates = [
    {
      date: 'Prochainement',
      title: 'Interface utilisateur avec liste de favoris',
      status: 'planned',
      description: 'Ajout d\'une fonctionnalité permettant aux utilisateurs de sauvegarder leurs projets favoris et d\'y accéder facilement.',
      features: [
        'Création d\'un système de favoris',
        'Interface de gestion des favoris',
        'Synchronisation entre appareils',
        'Notifications pour les mises à jour des projets favoris'
      ]
    },
    {
      date: 'Après l\'interface utilisateur',
      title: 'Amélioration de la recherche',
      status: 'planned',
      description: 'Optimisation du système de recherche pour une meilleure expérience utilisateur.',
      features: [
        'Recherche par nom d\'architecte',
        'Filtres par année',
        'Historique des recherches'
      ]
    },
    {
      date: '2024-03-10',
      title: 'Système de contribution',
      status: 'completed',
      description: 'Sorti de la première version de l\'application.',
      features: [
        'Recherche par localisation et nom de projet',
        'Filtre par Type et Programme',
        'Direction vers le projet',
        'Renvoie vers Google Maps',
        'Interface d\'administration'
      ]
    }
  ];

  const getStatusBadge = (status) => {
    const statusStyles = {
      'planned': { class: 'status-planned', text: 'Planifié' },
      'completed': { class: 'status-completed', text: 'Terminé' }
    };

    const style = statusStyles[status];
    return <span className={`status-badge ${style.class}`}>{style.text}</span>;
  };

  return (
    <div className="devlog-container">
      <header className="devlog-header">
        <h1>Journal de développement</h1>
        <p>Suivez l'évolution du projet Arkastra et découvrez les fonctionnalités à venir</p>
      </header>

      <div className="devlog-content">
        {devUpdates.map((update, index) => (
          <article key={index} className="devlog-entry">
            <div className="devlog-entry-header">
              <h2>{update.title}</h2>
              {getStatusBadge(update.status)}
            </div>
            <div className="devlog-entry-date">
              {new Date(update.date).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </div>
            <p className="devlog-entry-description">{update.description}</p>
            <div className="devlog-entry-features">
              <h3>Fonctionnalités :</h3>
              <ul>
                {update.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default DevLog; 